"use client";
import React from "react";
import { Stack } from "@mui/material";
import { SxProps, Theme } from "@mui/material";

import ReactSpeedometer, { Props } from "react-d3-speedometer";

export type WcSpeedometerProps = Props & {
  sx?: SxProps<Theme>;
  speedometerCalcWidth: number;
};

export const WcSpeedometer = ({ sx, speedometerCalcWidth, ...props }: WcSpeedometerProps) => {
  const [usedWidth] = React.useState(speedometerCalcWidth);
  const [usedHeight] = React.useState(speedometerCalcWidth);
  const [usedRingWidth, setUsedRingWidth] = React.useState<number>();
  const [usedNeedleHeightRatio, setUsedNeedleHeightRatio] = React.useState<number>(0.5);

  // sigmoid function as the needle height ratio has to be between 0 and 1, calculated from the height of the ring
  const sigmoid = (z) => 1 / (1 + Math.exp(-z / 2));

  React.useEffect(() => {
    const calculateNeedleheightRatio = sigmoid(speedometerCalcWidth * 0.005);
    if (speedometerCalcWidth < 100) {
      setUsedRingWidth(speedometerCalcWidth * 0.1);
    } else {
      setUsedRingWidth(speedometerCalcWidth * 0.2);
    }
    setUsedNeedleHeightRatio(calculateNeedleheightRatio);
  }, [speedometerCalcWidth]);

  return (
    <Stack width={usedWidth} height={usedHeight} key={usedRingWidth}>
      <ReactSpeedometer
        fluidWidth={props.fluidWidth ? props.fluidWidth : true}
        ringWidth={usedRingWidth ? usedRingWidth : 60}
        needleHeightRatio={usedNeedleHeightRatio}
        {...props}
      />
    </Stack>
  );
};

export default WcSpeedometer;
